import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import * as moment from 'moment';

@Component({
    selector: 'app-benefits',
    templateUrl: './benefits.component.html',
    styleUrls: ['./benefits.component.css']
})
export class BenefitsComponent implements OnInit {

    constructor(public httpClient: HttpClient) { }

    ngOnInit(): void {}
    time :any={};
    timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
    sort_model:string = 'desc';
    data:any=[];
    edit_data:any=[];
    loading:boolean=true;
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));
    recharge_num = 0;
    recharge = 0;

    menu_now:string = '1';
    now:string = '1';  
    menu_list:menulist = [
        {id:'1',name:'生日數據列表'},
    ]

    tcontent = [
        {title:'獎勵標題',content:'title'},
        {title:'獎勵描述',content:'description'},
        {title:'生日 (可領獎日)',content:'date'},
        {title:'狀態',content:'status',type:3},
        {title:'通知狀態',content:'sms_status',type:3},
        {title:'領獎後儲值次數 (負值代表領獎前30天內有儲值)',content:'recharge_num',type:3,css:'width: 29%;',sort:'recharge_num'},
        {title:'領獎後儲值金額 (負值代表領獎前30天內有儲值)',content:'recharge',type:3,css:'width: 29%;',sort:'recharge'},
    ];

    sort_obj = {column:'id',sort:'0'};
    
    search_benefits = '-5';
    search_top_up = '0';

    top_up_list:menulist = [
        {id:'0',name:'不限'},
        {id:'1',name:'有儲值'},
        {id:'2',name:'沒儲值'},
        {id:'3',name:'過去有儲值'},
    ]

    benefits_list:menulist = [
        {id:'-5',name:'請選擇狀態'},
        {id:'-4',name:'派發失敗'},
        {id:'-1',name:'過期'},
        {id:'0',name:'未派'},
        {id:'1',name:'已派'},
    ]
    
    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    default(){
        this.data = [];
        this.pageobj = {page:0,count:10,total_count:0};
        this.pageobjstr =JSON.parse(JSON.stringify(this.pageobj));
    }

    toNumber(value: any): number {
        return Number(value);
    }
    
    handleRangeSelected(value: any): void {
        let eventDate = value.event;
    
        this.time.startDate = '';
        this.time.endDate = '';
    
        // 如果没有选择日期，则将默认值设置为今天
        if (eventDate.startDate) {
            this.time.startDate = moment(eventDate.startDate).format('YYYY-MM-DD');
            this.time.endDate = moment(eventDate.endDate).format('YYYY-MM-DD');
        } else {
            const today = moment().format('YYYY-MM-DD');
            this.time.startDate = today;
            this.time.endDate = today;
        }
    
        this.init_list();
    }


    init_list(){
        this.loading = true;
        const body = {
            time:this.time,
            page: this.pageobj.page,
            count:this.pageobj.count,
            sort:this.sort_model,
            sort_obj:this.sort_obj,
            search_benefits:this.search_benefits,
            search_top_up:this.search_top_up
        };
        this.httpClient.post<any>("/v1/data_analyze/get_birthday_reward_record.php",body).subscribe(res => {
            this.loading = false;
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
            if(res.status){
                this.data = res.data;
                console.log('dataaa',this.data);
                this.pageobj.total_count = res.total_count;
                this.pageobjstr =JSON.parse(JSON.stringify(this.pageobj));
                this.recharge = res.recharge;
                this.recharge_num = res.recharge_num;
            }
        });
    }


    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }


}
